import { render, staticRenderFns } from "./WarehouseManage.vue?vue&type=template&id=c0bb9196&scoped=true"
import script from "./WarehouseManage.vue?vue&type=script&lang=js"
export * from "./WarehouseManage.vue?vue&type=script&lang=js"
import style0 from "./WarehouseManage.vue?vue&type=style&index=0&id=c0bb9196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb9196",
  null
  
)

export default component.exports